import React from 'react';
import { Redirect } from 'react-router-dom';

const ForgotPassword: React.FC = () => (
    <Redirect to={{ pathname: '/login', state: { authView: 'forgot' } }} />
);

export default ForgotPassword;
